import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { getOtherIcons } from 'src/styles/font';
import { flex } from 'src/styles/utils';
import { OtherIconsSet } from 'src/utils/constants/IconsConstants';

export const container = css`
  color: ${colors.Purple};
  background: ${colors.PrimaryWhiteColorAlpha10};
  border-radius: 8px 0 0 8px;
  width: 44px;
  height: 44px;
  ${flex()};
  cursor: pointer;
  box-sizing: border-box;
  position: fixed;
  bottom: 10px;
  right: 0px;
  opacity: 0;
  z-index: 20;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transition: opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const showContainer = css`
  opacity: 1;
`;

export const ArrowUp = css`
  font-size: 30px;
  ${getOtherIcons(OtherIconsSet.ARROW)};
  transform: rotate(90deg);
`;
